<template>
  <div id="app">
      <!-- <Header></Header> -->
      <router-view></router-view>
      <Service v-show="!$route.meta.show"></Service>
  </div>
</template>

<script>
import Service from './components/Tool/Service.vue';
export default {
  name: 'app',
  data() {
    return {
      
    }
  },
  components:{
    Service
  },
  mounted(){
    // this.$router.go(0)
  }
}
</script>
<style>
::-webkit-scrollbar{
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px #e8e8e8;
  background-color: #e8e8e8;
  opacity: 0.2;
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgb(0 0 0 / 0%);
  border-radius: 4px;
}

</style>
